import React, { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Routes, Route, useRouteError } from "react-router-dom";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import SignInCert from './SignInCert';
import { AuthProvider, useAuth } from "./useAuth";
import { AppBar } from "./AppBar";
import { Home } from "./Home";
import { Rezerv } from "./Rezerv";
import { Stat } from "./Stat";
import { Codes } from "./Codes";
import { Test } from "./Test";
import oConf from './conf';

const { bDevMode, oUrlOptsInit } = oConf[process.env.REACT_APP_TEST ? 'oDev' : 'oProd'];
const Profile = () => <div>Profile</div>;
const Settings = () => <div>Версия от 06.10.2026 г.</div>;

function ErrorBoundary() {
    let error = useRouteError();
    console.error(error);
    // Uncaught ReferenceError: path is not defined
    return <div>Dang!</div>;
}

const theme = createTheme({
    palette: {
        primary: {
            light: '#faf995',
            main: '#fcff25',
            dark: '#bdbf07',
            contrastText: 'unset',
        },
        secondary: {
            light: '#ff7961',
            main: '#5ca6dc',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
});

const App = () => <BrowserRouter>
    <AuthProvider>
       <ThemeProvider theme={theme}>
            <Routes>
                <Route path="/login" element={<SignInCert />} errorElement={<ErrorBoundary />} />
                <Route element={<MainLayout />}>
                    <Route path={"/"} element={<Home />} />
                    <Route path={"/rezerv"} element={<Rezerv />} />
                    <Route path={"/stat"} element={<Stat />} />
                    <Route path={"/codes"} element={<Codes />} />
                    <Route path={"/test"} element={<Test />} />
                    <Route path={"/profile"} element={<Profile />} />
                    <Route path={"/settings"} element={<Settings />} />
                </Route>
            </Routes>
        </ThemeProvider>
    </AuthProvider>
</BrowserRouter>

export default App;

const MainLayout = () => {
    const { user } = useAuth();
    const [aAreas, setAreas] = useState([]);
    const [urlOpts, setUrlOpts] = useState(oUrlOptsInit);
    const [postBody, setPostBody] = useState(oConf.aPostBodyInit);
    const location = useLocation();

    useEffect(() => {
        if(location.pathname != "/codes") {
            setUrlOpts(oUrlOptsInit);
            setPostBody(oConf.aPostBodyInit);
        }
    }, [location]);

    // useEffect(() => {
    //     db.get('unprinted').then(res => setUnPrintedSet(new Set(res.cises)));
    // }, []);

    if (!user) return <Navigate to="/login" />;

    return (
        <div>
            <AppBar
                pages={[
                    { label: "Главная", path: "/" },
                    { label: "Статистика", path: "/stat" },
                    { label: "Коды", path: "/codes" },
                    { label: "Резерв", path: "/rezerv" },
                ].concat(bDevMode ? [{ label: "Test", path: "/test" }] : [])}
                settings={[
                    { label: "Профиль", path: "profile" },
                    { label: "Настройки", path: "settings" },
                ]}
            />
            <Outlet context={{
                urlOpts, setUrlOpts,
                postBody, setPostBody,
                aAreas, setAreas,
                user
            }} />
        </div>
    );
};